// Strictly typed TrackStatusPage.tsx
import React, { useState, FC } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import CustomerLoginForm from './CustomerLoginForm'
import CustomerOTPSubmitForm from './CustomerOTPSubmitForm'
import { AuthenticationService } from '../../services'
import { TicketList } from './TicketList'

interface OTPRequestValues {
  contact_number: string
  [key: string]: any
}

interface OTPVerifyValues extends OTPRequestValues {
  otp: string
  otp_uuid?: string
}

export const TrackStatusPage: FC = () => {
  const [OTPRequestInfo, setOTPRequestInfo] = useState<OTPRequestValues | null>(null)
  const [OTPInfo, setOTPInfo] = useState<any>(null)
  const [data, setData] = useState<any[] | null>(null)
  const [OTPAttempt, setOTPAttempt] = useState<number>(0)
  const [step, setStep] = useState<number>(1)
  const [errors, setErrors] = useState<string | null>(null)

  const getOTPHandler = (values: OTPRequestValues) => {
    const payload = values?.contact_number ? values : OTPRequestInfo
    if (!payload) return

    setOTPRequestInfo(payload)
    AuthenticationService.requestOTP(payload)
      .then((response: any) => {
        setErrors(null)
        setOTPInfo(response)
        setStep(2)
      })
      .catch((error: any) => {
        setErrors(error)
      })
  }

  const verifyOTPHandler = (values: OTPVerifyValues) => {
    if (!OTPInfo || !OTPRequestInfo) return

    values.otp_uuid = OTPInfo.otp_uuid
    values.contact_number = OTPRequestInfo.contact_number

    AuthenticationService.verifyCustomerOTP(values)
      .then((response: any) => {
        setStep(3)
        setData(response.data)
      })
      .catch((error: any) => {
        const count = OTPAttempt + 1
        setOTPAttempt(count)
        const pendingAttempt = 3 - count
        if (pendingAttempt > 0) {
          setErrors(`Could not verify OTP correctly. ${pendingAttempt} attempts pending.`)
        } else {
          setErrors(`Could not verify OTP correctly`)
          setOTPAttempt(0)
          setStep(1)
        }
      })
  }

  return (
    <div className="pl-0 pr-0">
      {step === 1 && (
        <>
          <ReactBootstrap.Card.Title className="text-dark">
            <strong>Let us know your registered mobile number.</strong>
          </ReactBootstrap.Card.Title>
          <div className="mt-3">
            <components.ErrorDisplay error={errors} />
            <CustomerLoginForm onSubmit={getOTPHandler} />
          </div>
        </>
      )}
      {step === 2 && (
        <>
          <ReactBootstrap.Card.Title className="text-dark">
            <strong>You’ll receive an OTP shortly—enter it here to continue securely.</strong>
          </ReactBootstrap.Card.Title>
          <div className="mt-3">
            <components.ErrorDisplay error={errors} />
            <CustomerOTPSubmitForm
              getOTPHandler={getOTPHandler}
              goBack={() => setStep(1)}
              onSubmit={verifyOTPHandler}
            />
          </div>
        </>
      )}
      {step === 3 && data && <TicketList tickets={data} />}
    </div>
  )
}
